import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {CompositeProductComponentSearchData} from "./composite-product-component-search.data";

@Injectable()
export class CompositeProductComponentSearchModel extends SearchModel<CompositeProductComponentSearchData> {
    constructor(injector: Injector) {
        super(injector, CompositeProductComponentSearchData);
    }
}
